import React from 'react'
import './Usuarios.css'
import Header from '../Header/Header'
import UsuariosData from '../../components/Admin/UsuariosData/UsuariosData'
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash'
export default function Usuarios() {
    return (
        <div className='containerGrid'>
            <Header />



            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <UsuariosData />
                </div>
            </section>
        </div>
    )
}
